/**
 * Brand mark for app headers:
 *   StartupDrive (link to startupdrive.ru) | hop.agency (link to hop.agency) + "Hop · Diagnostic" wordmark.
 *
 * Both logos are external links opened in a new tab. The whole image is clickable.
 *
 * Props:
 *   - dark: invert StartupDrive logo for dark backgrounds (its text is dark on transparent)
 */
export default function BrandMark({ dark = false, className = "", testId = "brand-mark" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 sm:gap-3 ${className}`}
      data-testid={testId}
    >
      <a
        href="https://startupdrive.ru/"
        target="_blank"
        rel="noreferrer noopener"
        className="inline-flex items-center no-underline"
        title="StartupDrive"
        data-testid="brand-startupdrive-link"
      >
        <img
          src="/startupdrive-logo.png"
          alt="StartupDrive"
          draggable={false}
          className="block select-none"
          style={{
            height: 24,
            width: "auto",
            WebkitUserDrag: "none",
            filter: dark ? "invert(1) brightness(2)" : undefined,
          }}
        />
      </a>

      <a
        href="https://hop.agency"
        target="_blank"
        rel="noreferrer noopener"
        className="inline-flex items-center gap-2 sm:gap-2.5 no-underline"
        title="hop.agency"
        data-testid="brand-hop-link"
      >
        <img
          src="/hop-logo.png"
          alt="hop.agency"
          width={26}
          height={26}
          draggable={false}
          className="block select-none"
          style={{ borderRadius: 4, WebkitUserDrag: "none" }}
        />
        <span className="font-mono text-sm tracking-widest uppercase whitespace-nowrap hidden sm:inline">Hop · Diagnostic</span>
      </a>
    </span>
  );
}
